import * as React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

import ImportExportHome                from "./importexport";          // existing list page
import ImportExportManualWithApollo    from "../templates/ImportExportManualWithApollo";

export default function ImportExportShell() {
  if (typeof window === "undefined") {
    return (
      <Box sx={{
        minHeight: "100vh", display:"flex",
        alignItems:"center", justifyContent:"center"
      }}>
        <CircularProgress size={60}/>
      </Box>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        {/* token may be supplied on either route */}
        <Route path="/importexport" element={<ImportExportHome />} />
        <Route
          path="/importexport/manual/:manualId/site/:siteId/*"
          element={<ImportExportManualWithApollo />}
        />
        <Route
          path="/importexport/manuals/:manualId/site/:siteId/*"
          element={<ImportExportManualWithApollo />}
        />
      </Routes>
    </BrowserRouter>
  );
}
